import { render } from "./CompareProducts.vue?vue&type=template&id=1e704b1c&ts=true"
import script from "./CompareProducts.vue?vue&type=script&lang=ts"
export * from "./CompareProducts.vue?vue&type=script&lang=ts"

import "./CompareProducts.vue?vue&type=style&index=0&id=1e704b1c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__